import { render, staticRenderFns } from "./InforPage.vue?vue&type=template&id=51818e1c&scoped=true"
var script = {}
import style0 from "./InforPage.vue?vue&type=style&index=0&id=51818e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51818e1c",
  null
  
)

export default component.exports